import { Reveal } from '../components/Reveal';
import { gateway } from '../content/wedding';

/**
 * The three doors off the landing page.
 *
 * Where the whole invitation used to unroll. Each card names a page and says
 * enough about it that a guest can pick without opening all three — the date
 * and the venue on one, the room block on another, us on the third.
 *
 * Drawn as banded rows rather than as a rank of boxes: the page is an
 * invitation, and three shaded tiles in a row would read as an advertisement
 * for somewhere else. The hairline between them is the same one the schedule
 * and the FAQ are built from.
 */
export function Gateway() {
  return (
    <section class="section gate">
      <div class="shell">
        {gateway.map((card, i) => (
          <Reveal as="article" class="gate__card" key={card.href} delay={i * 90}>
            <div class="gate__head">
              <span class="eyebrow">{card.kicker}</span>
              <h2 class="gate__title">{card.title}</h2>
              {card.lines.length > 0 && (
                <p class="gate__lines">
                  {card.lines.map((line) => (
                    <span key={line}>{line}</span>
                  ))}
                </p>
              )}
            </div>

            <div class="gate__body">
              <p class="gate__text">{card.body}</p>
              {/* The whole card is not the link: a card that is one big target
                  gives a guest nothing to aim at and no way to know they have
                  arrived. The button is the link, and it says where it goes. */}
              <a class="btn gate__cta" href={card.href}>
                {card.cta}
                <span aria-hidden="true">&rarr;</span>
              </a>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
